import actionTypes from 'constants/actionTypes'
import defaultsDeep from 'lodash/defaultsDeep'

interface ResetPasswordState {
  isFetching: boolean
}

interface ResetPasswordAction {
  type?: string
}

const initialState: ResetPasswordState = {
  isFetching: false,
}

export default (state: ResetPasswordState = initialState, action: ResetPasswordAction): ResetPasswordState => {
  if (action.type === actionTypes.AUTH.RESET_PASSWORD.REQUEST) {
    return defaultsDeep(
      {
        isFetching: true
      },
      state
    )
  }
  if (action.type === actionTypes.AUTH.RESET_PASSWORD.RECEIVE) {
    return defaultsDeep(
      {
        isFetching: false
      },
      state
    )
  }
  if (action.type === actionTypes.AUTH.RESET_PASSWORD.FAIL) {
    return defaultsDeep(
      {
        isFetching: false
      },
      state
    )
  }
  return state
}
